import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BasketPageComponent } from 'libs/shared/src/lib/page/basket/basket.component';

@Component({ standalone: false, selector: 'app-page-basket', templateUrl: './basket.component.html' })
export class CustomBasketPageComponent extends BasketPageComponent implements OnInit, AfterViewInit, OnDestroy {}
